import { useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { CheckCircle2 } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/contact", form);
      setSent(true);
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      setError(err.response?.data?.detail || "Une erreur est survenue. Merci de réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16 fade-in">
      <div className="label-eyebrow text-accent mb-3">Contact</div>
      <h1 className="font-serif text-5xl tracking-tight">Écrivez-nous</h1>
      <p className="mt-4 text-muted-foreground">Une question, une remarque, un partenariat ? Envoyez-nous un message via le formulaire.</p>

      {sent ? (
        <div data-testid="contact-success" className="mt-12 p-8 border border-border bg-secondary/40 flex items-start gap-4">
          <CheckCircle2 className="w-6 h-6 text-accent mt-1 shrink-0" />
          <div>
            <div className="font-serif text-xl">Merci pour votre message.</div>
            <p className="mt-2 text-muted-foreground text-sm">
              Nous vous répondrons dans les meilleurs délais.
            </p>
            <Button data-testid="contact-again" variant="outline" className="mt-6 rounded-sm" onClick={() => setSent(false)}>
              Envoyer un autre message
            </Button>
          </div>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-12 space-y-5">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div>
              <Label htmlFor="c-name">Nom</Label>
              <Input id="c-name" data-testid="contact-name" required value={form.name} onChange={update("name")} className="mt-2 rounded-sm bg-transparent" />
            </div>
            <div>
              <Label htmlFor="c-email">E-mail</Label>
              <Input id="c-email" type="email" data-testid="contact-email" required value={form.email} onChange={update("email")} className="mt-2 rounded-sm bg-transparent" />
            </div>
          </div>
          <div>
            <Label htmlFor="c-subject">Sujet</Label>
            <Input id="c-subject" data-testid="contact-subject" required value={form.subject} onChange={update("subject")} className="mt-2 rounded-sm bg-transparent" />
          </div>
          <div>
            <Label htmlFor="c-message">Message</Label>
            <Textarea id="c-message" data-testid="contact-message" required rows={6} value={form.message} onChange={update("message")} className="mt-2 rounded-sm bg-transparent" />
          </div>
          {error && <div className="text-sm text-destructive">{error}</div>}
          <div>
            <Button type="submit" data-testid="contact-submit" disabled={loading} className="rounded-sm h-11 px-8">
              {loading ? "Envoi..." : "Envoyer"}
            </Button>
          </div>
        </form>
      )}
    </div>
  );
}
